import { Alert, FormControlLabel, FormGroup, } from '@mui/material'
import { RedSwitch } from '../watchlist/WatchList'
import { useEffect, useState } from 'react'
import ATSnackbar from '../layout/ATSnackbar'



const TradeSwitch = ({ user, type }) => {
    const [currentStatus, setCurrentStatus] = useState()

    // This alert will be present at the beginning if there is an error fetching the current status
    const [persistentError, setPersistentError] = useState({
        message: '',
        open: false,
    })

    // This alert will be shown for success/error messages on toggle action
    const [snackbar, setSnackbar] = useState({
        message: '',
        open: false,
        severity: 'error'
    })

    useEffect(() => {
        fetchCurrentValue()
    }, [type, user]);

    const fetchCurrentValue = () => {
        fetch(`/algo-trading/api/admin/trade-config/${type}`,
            {
                headers: {
                    'Authorization': user?.credential
                }
            })
            .then(response => {
                if (response.status != 200) {
                    throw new Error('Error fetching trade config');
                }
                return response;
            })
            .then(response => response?.json())
            .then(data => {
                setCurrentStatus(data);
                resetAlert()
            })
            .catch(error => {
                console.error("Error fetching trade config:", error)
                setPersistentError({
                    message: 'Error fetching trade config',
                    open: true,
                    severity: 'error'
                })
            });
    }


    const onSwitchToggle = (event) => {
        const toggleStatus = event?.target?.checked;
        toggleSwitch(toggleStatus);
    }

    const toggleSwitch = (status) => {
        fetch(`/algo-trading/api/admin/trade-config/toggle`,
            {
                method: 'POST',
                headers: {
                    'Authorization': user?.credential,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ type, value: status ? 'ON' : 'OFF' })
            })
            .then(response => {
                if (response.status != 201) {
                    throw new Error('Error updating trade config: ' + response?.text());
                }
                return response?.text();
            })
            .then(data => {
                setSnackbar({ message: data, open: true, severity: 'success' })
                fetchCurrentValue()
            })
            .catch(error => {
                console.error("Error updating trade config:", error)
                setSnackbar({
                    message: 'Error updating trade config', open: true, severity: 'error'
                });
            })
    }

    const resetAlert = () => setPersistentError({ message: '', open: false, severity: 'error' })
    const resetSnackbar = () => setSnackbar({ message: '', open: false, severity: 'error' })


    return (
        <>
            <ATSnackbar message={snackbar?.message} open={snackbar?.open} setOpen={(open) => setSnackbar(prev => ({ ...prev, open }))} severity={snackbar?.severity} />
            {persistentError?.open ? <Alert severity='error'>{persistentError.message}</Alert> :
                <FormGroup style={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                    <FormControlLabel
                        control={
                            <div style={{ transform: 'scale(1.5)', display: 'inline-block', color: 'green' }}>
                                <RedSwitch checked={currentStatus?.value === 'ON'} onChange={onSwitchToggle} />
                            </div>
                        }
                        label={<span style={{ marginRight: 16 }}>{type}</span>}
                        labelPlacement='start'
                    />
                </FormGroup>
            }
        </>
    )
}

export default TradeSwitch